import React from "react"
import { RichUtils } from "draft-js"
import styled from "styled-components"
import Color from "../../../../../../../../../../style/enum/color"
import { IToolBarProps } from "."

export const FontWeightButton = (props: IToolBarProps) => {
  const toggleWeight = () =>
    props.onChange(
      RichUtils.toggleInlineStyle(props.editorState, "FONT_WEIGHT_BOLD"),
    )
  return <StyleButton onClick={toggleWeight}>太字</StyleButton>
}

const StyleButton = styled.button`
  background-color: ${Color.TRANSPARENT};
  font-weight: bold;
  border: 1px solid ${Color.LIGHT_GRAY};
  border-radius: 4px;
  font-size: 0.9rem;
  height: 36px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Color.DIMGRAY};
`
